<span id="tooltip-1" class="d-flex-inline justify-content-center">
  <span (mouseover)="checkPosition()" class="tooltip">
    <i class="{{elementClass}}" aria-hidden="true" [ngStyle]="{'color': color}">
      <span style="font-size: 13px; font-family: 'Work Sans', sans-serif" class="tooltip-content"
            *ngIf="content"
            [ngClass]="tooltipPosition === TOOLTIP_POSITION.TOP || tooltipPosition === TOOLTIP_POSITION.BOTTOM
            ? 'tooltip-' + tooltipPosition + '-' + caretPosition : 'tooltip-' + tooltipPosition" [ngStyle]="{'width': width}">
        <span style="display: flex; flex-direction: column;width: 100%;">
          <div *ngIf="image">
            <img src= {{image}} style="width: 100%;height: 100%;" >
          </div>
          <div *ngIf="image" style="
          font-size: 15px;
          font-weight: 400;
          line-height: 16.25px;
          letter-spacing: 0.25px;
          text-align: left;
          margin-top: 10px;
          "
          [ngStyle]="{ 'margin-top': (image ? '10px' : '0') }">{{content}}</div>
          <div *ngIf="!image">{{content}}</div>
        </span>
        <i class="caret" [ngClass]="'caret-' + caretPosition"></i>
      </span>
    </i>
  </span>
</span>
